import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  NavItem,
  CardHeader,
  Nav,
} from 'reactstrap';
import { Separator } from '../../../../../components/common/CustomBootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { getGroupID } from '../../../../../helpers/AxiosAPI';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import '../style/style.css';

export default function VoucherCodeSnippet({ integration }) {
  const [value, setValue] = useState('');
  const [iframevalue, setIframeValue] = useState('');
  const [copied, setCopied] = useState(false);
  const [iframecopied, setIframeCopied] = useState(false);
  const [activeTab, setActiveTab] = useState('standard');
  useEffect(() => {
    const gid = getGroupID();
    const iid = integration.id;
    const text = `<!-- This is start of the  voucher assistant code -->
    <script>
    var BMB_Voucher_domain = 'https://chatapps.bookmebob.com/';
    var BMB_Voucher_botHTMLPath = BMB_Voucher_domain;
    var BMB_Voucher_head = document.getElementsByTagName('head')[0];
    var BMB_Voucher_script = document.createElement('script');
    BMB_Voucher_script.type = 'text/javascript';
    BMB_Voucher_script.src = BMB_Voucher_domain + 'voucherplugin.js';
    BMB_Voucher_head.appendChild(BMB_Voucher_script);
    var BMB_Voucher_gid = '${gid}';
    var BMB_Voucher_iid = '${iid}';
    var BMB_Voucher_pid = '';
    </script>
<!-- This is end of the  voucher assistant code -->`;
    setValue(text);
    const iframetext = `<iframe frameborder="0" style="bottom: 0; right: 0; margin: 0; z-index: 2000001;height:630px;width:390px;" id="chatbotiframe" src="https://webchat.bookmebob.com?location=&amp;title=&amp;referrer=&amp;iid=${iid}&amp;gid=${gid}&amp;mobile=false&amp;open=1&custom=1"></iframe>`;
    setIframeValue(iframetext);
  }, []);

  const RedirectToDemo = () => {
    var url = `${process.env.REACT_APP_VOUCHER_BOT_DEMO
      }?gid=${getGroupID()}&iid=${integration.id}`;
    window.open(url, '_blank');
  };
  const RedirectToIframeDemo = () => {
    var url = `${process.env.REACT_APP_BOT_IFRAME_DEMO
      }?gid=${getGroupID()}&iid=${integration.id}`;
    window.open(url, '_blank');
  };

  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };

  return (
    <Fragment>
      <CardHeader className="pl-0 pr-0">
        <Nav tabs className="card-header-tabs ml-0 mr-0">
          <NavItem className="w-50 text-center">
            <NavLink
              className={classnames({
                active: activeTab === 'standard',
                'nav-link': true,
              })}
              onClick={() => {
                toggleAppMenu('standard');
              }}
              to="#"
            >
              Standard
            </NavLink>
          </NavItem>
          <NavItem className="w-50 text-center">
            <NavLink
              className={classnames({
                active: activeTab === 'embed',
                'nav-link': true,
              })}
              onClick={() => {
                toggleAppMenu('embed');
              }}
              to="#"
            >
              Embed
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <TabContent activeTab={activeTab} className="">
        <TabPane tabId="standard" className="chat-app-tab-pane">
          <Card className="mb-4">
            <CardBody>
              <h6 className="text-center">Publish your Assistant</h6>
              <Separator className="mb-3" />
              <div className="code-snippet">
                <span>
                  {' '}
                  &lt;&#33;&#45;&#45; This is start of the voucher
                  assistant code &#45;&#45;&gt;
                </span>
                <span>&lt;script&gt;</span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var BMB_Voucher_domain = '
                  {process.env.REACT_APP_BASE_CHATUI}/';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var BMB_Voucher_botHTMLPath =
                  BMB_Voucher_domain;
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var BMB_Voucher_head =
                  document.getElementsByTagName('head')[0];
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var BMB_Voucher_script =
                  document.createElement('script');
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;BMB_Voucher_script.type =
                  'text/javascript';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;BMB_Voucher_script.src =
                  BMB_Voucher_domain + 'voucherplugin.js';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;BMB_Voucher_head.appendChild(BMB_Voucher_script);
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var BMB_Voucher_gid = '{getGroupID()}
                  ';
                </span>
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;var BMB_Voucher_iid = '
                  {integration.id}';
                </span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;var BMB_Voucher_pid = '';</span>
                <span>&lt;/script&gt;</span>
                <span>
                  {' '}
                  &lt;&#33;&#45;&#45; This is end of the  voucher
                  assistant code &#45;&#45;&gt;{' '}
                </span>
              </div>
              <div className="text-center">
                <div>
                  <b>
                    Copy and paste this code before the closing &lt;/body&gt;
                    tag on every page of your website.
                  </b>
                </div>
                <CopyToClipboard text={value} onCopy={() => setCopied(true)}>
                  <Button
                    color="success"
                    size="xs"
                    style={{ marginTop: '10px' }}
                  >
                    Copy the code snippet
                  </Button>
                </CopyToClipboard>
                <Button
                  color="success"
                  size="xs"
                  style={{ marginTop: '10px', marginLeft: '20px' }}
                  onClick={RedirectToDemo}
                >
                  Preview
                </Button>
                {copied ? <div>Copied.</div> : null}
              </div>
            </CardBody>
          </Card>
        </TabPane>
        <TabPane tabId="embed" className="chat-app-tab-pane">
          <Card className="mb-4">
            <CardBody>
              <h6 className="text-center">Embed your Assistant</h6>
              <Separator className="mb-3" />
              <div className="code-snippet">
                <span>
                  &lt;iframe frameborder="0" style="bottom: 0; right: 0; margin:
                  0; z-index: 2000001;height:630px;width:390px;"
                  id="voucherbotiframe" src="{process.env.REACT_APP_BASE_CHATUI}
                  /voucherengine ?location=&amp;title=&amp;referrer=&amp;iid=
                  {integration.id}&amp;gid={getGroupID()}
                  &amp;mobile=false&amp;open=1&custom=1"&gt;&lt;/iframe&gt;
                </span>
              </div>
              <div className="text-center">
                <div>
                  <b>
                    Copy and paste this code at desired location on the page of
                    your website.
                  </b>
                </div>
                <CopyToClipboard
                  text={iframevalue}
                  onCopy={() => setIframeCopied(true)}
                >
                  <Button
                    color="success"
                    size="xs"
                    style={{ marginTop: '10px' }}
                  >
                    Copy the code snippet
                  </Button>
                </CopyToClipboard>
                <Button
                  color="success"
                  size="xs"
                  style={{ marginTop: '10px', marginLeft: '20px' }}
                  onClick={RedirectToIframeDemo}
                >
                  Preview
                </Button>
                {iframecopied ? <div>Copied.</div> : null}
              </div>
            </CardBody>
          </Card>
        </TabPane>
      </TabContent>
    </Fragment>
  );
}
